import React from "react";
import {
  BrowserRouter,
  Switch,
  withRouter,
  Route,
  Redirect,
} from "react-router-dom";
import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core";
import { styles } from "./styles";
import {
  AdminSideMenu,
  AuditInfo,
  CountryData,
  AccessControlRules,
  SystemActions,
  Dashboard,
} from "./Component";
import { DetailedRecord } from "../../Container";

const AdminContainer = (props) => {
  const { user, hasPermission, hasAnyRecordPermission, hasRecordPermission } =
    props;
  return (
    <div>
      <BrowserRouter basename="/glc/admin">
        <AdminSideMenu
          hasPermission={hasPermission}
          hasAnyRecordPermission={hasAnyRecordPermission}
        />
        <Switch>
          <Route exact path="/">
            <Redirect to="/dashboard" />
          </Route>
          <Route path="/auditInfo">
            <AuditInfo hasPermission={hasPermission} />
          </Route>
          <Route path="/dashboard">
            <Dashboard hasPermission={hasPermission} />
          </Route>
          <Route path="/countryData">
            <CountryData hasPermission={hasPermission} />
          </Route>
          <Route path="/accessControl">
            <AccessControlRules hasPermission={hasPermission} />
          </Route>
          <Route path="/system">
            <SystemActions hasPermission={hasPermission} />
          </Route>
          <Route path="/viewAuditedRecord">
            <DetailedRecord
              user={user}
              hasPermission={hasPermission}
              hasRecordPermission={hasRecordPermission}
            />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default withRouter(
  withApollo(withStyles(styles, { withTheme: true })(AdminContainer)),
);
